/* eslint-disable no-case-declarations */
import { MapBoxStyleSpecService } from '../../../carried-over-from_1.10/mapbox-style-spec.service';
import { VectorStyleLayer } from '../../../layer-type-services/vector-tile/twc-vector-tile.layer';

export const TWC_HIGH_LEVEL_SIGNIFICANT_VECTOR_STYLE_LAYERS: VectorStyleLayer[] =
  [
    {
      layout: {},
      paint: {
        'fill-color': '#FF7200',
        'fill-antialias': true,
        'fill-outline-color': '#FC7404',
        'fill-opacity': 0.2
      },
      source: 'twc',
      minzoom: 0,
      maxzoom: 28,
      'source-layer': 'source-layer',
      id: 'turbulence-fill',
      filter: ['==', 'layer_name', 'TURBULENCE'],
      type: 'fill'
    },
    {
      layout: {
        'icon-image': [
          'concat',
          ['get', 'layer_name'],
          '_',
          MapBoxStyleSpecService.getAttributeFromCompositeObject(
            'turbulence_type'
          )
        ],
        'icon-size': 0.1,
        'text-field': [
          'concat',
          MapBoxStyleSpecService.getAttributeFromCompositeObject(
            'turb_upper_level'
          ),
          '\n',
          '\n',
          '\n',
          MapBoxStyleSpecService.getAttributeFromCompositeObject(
            'turb_base_level'
          )
        ],
        'text-size': 8,
        'text-offset': [0, 0.3]
      },
      paint: {
        'text-color': '#FF7200'
      },
      source: 'twc',
      minzoom: 0,
      maxzoom: 28,
      'source-layer': 'source-layer',
      id: 'turbulence-symbol',
      filter: ['==', 'layer_name', 'TURBULENCE'],
      type: 'symbol'
    },
    {
      layout: {
        'icon-image': [
          'case',
          [
            '==',
            MapBoxStyleSpecService.getAttributeFromCompositeObject('trop_type'),
            'SPOT'
          ],
          'TROPOPAUSE_SPOT',

          [
            '==',
            MapBoxStyleSpecService.getAttributeFromCompositeObject('trop_type'),
            'HIGH'
          ],
          'TROPOPAUSE_HIGH',

          [
            '==',
            MapBoxStyleSpecService.getAttributeFromCompositeObject('trop_type'),
            'LOW'
          ],
          'TROPOPAUSE_LOW',
          ''
        ],
        'icon-size': 0.3,
        'text-field': [
          'case',
          [
            '==',
            MapBoxStyleSpecService.getAttributeFromCompositeObject('trop_type'),
            'SPOT'
          ],
          MapBoxStyleSpecService.getAttributeFromCompositeObject('trop_height'),

          [
            '==',
            MapBoxStyleSpecService.getAttributeFromCompositeObject('trop_type'),
            'HIGH'
          ],
          [
            'concat',
            'H',
            '\n',
            MapBoxStyleSpecService.getAttributeFromCompositeObject(
              'trop_height'
            )
          ],

          [
            '==',
            MapBoxStyleSpecService.getAttributeFromCompositeObject('trop_type'),
            'LOW'
          ],
          [
            'concat',
            MapBoxStyleSpecService.getAttributeFromCompositeObject(
              'trop_height'
            ),
            '\n',
            'L'
          ],

          ''
        ],
        'text-size': 10,
        'text-offset': [0, 0.25]
      },
      paint: {
        'text-color': '#4E4E4E'
      },
      source: 'twc',
      minzoom: 0,
      maxzoom: 28,
      'source-layer': 'source-layer',
      id: 'tropopause-symbol',
      filter: ['==', 'layer_name', 'TROPOPAUSE'],
      type: 'symbol'
    },
    {
      layout: {
        'icon-image': 'VOLCANO',
        'icon-size': 0.075
      },
      paint: {},
      source: 'twc',
      minzoom: 0,
      maxzoom: 28,
      'source-layer': 'source-layer',
      id: 'volcano-symbol',
      filter: ['==', 'layer_name', 'VOLCANO'],
      type: 'symbol'
    },
    {
      layout: {
        'line-cap': 'round'
      },
      paint: {
        'line-color': '#0078B7',
        'line-width': 5
      },
      filter: ['==', 'layer_name', 'JET_STREAM'],
      source: 'twc',
      minzoom: 0,
      maxzoom: 28,
      'source-layer': 'source-layer',
      id: 'jet-stream',
      type: 'line'
    },

    /**
     * A request has been made to mapbox to add 'justEnd' and 'justBegin' symbol-placement options to
     * allow for us to use this to make end arrows using vectorstyles instead of a separate GeoJSON layer
     * https://github.com/mapbox/mapbox-gl-js/issues/13140
     */
    // {
    //   id: 'jet-stream-tip',
    //   type: 'symbol',
    //   source: 'twc',
    //   filter: ['==', 'layer_name', 'JET_STREAM'],
    //   'source-layer': 'source-layer',
    //   layout: {
    //     'symbol-placement': 'line', // 'justEnd'
    //     'icon-ignore-placement': true,
    //     'icon-image': 'JET_STREAM_HEAD',
    //     'icon-rotate': 180, // Rotate the symbols by 180 degrees
    //     'icon-size': 1,
    //     'symbol-spacing': 100, // Adjust spacing as needed
    //     'icon-allow-overlap': true
    //   },
    //   minZoom: 0,
    //   maxZoom: 28
    // },
    {
      layout: {
        'icon-image': 'JET_STREAM_POINT_DATA',
        'icon-size': 0.3,
        'icon-ignore-placement': true,
        'text-field': [
          'concat',
          MapBoxStyleSpecService.getAttributeFromCompositeObject(
            'jet_wind_speed'
          ),
          ' ',
          'KT',
          '\n',
          'FL',
          ' ',
          MapBoxStyleSpecService.getAttributeFromCompositeObject(
            'jet_wind_level'
          )
        ],
        'text-size': 8,
        'text-offset': [0, 0.2]
      },
      paint: {
        'text-color': '#FFFFFF'
      },
      source: 'twc',
      minzoom: 0,
      maxzoom: 28,
      'source-layer': 'source-layer',
      id: 'jet-stream-point-data',
      filter: ['==', 'layer_name', 'JET_STREAM_POINT_DATA'],
      type: 'symbol'
    },
    {
      layout: {},
      paint: {
        'fill-color': '#C90015',
        'fill-outline-color': '#C90015',
        'fill-opacity': 0.2
      },
      source: 'twc',
      minzoom: 0,
      maxzoom: 28,
      'source-layer': 'source-layer',
      id: 'convection-1',
      filter: ['==', 'layer_name', 'CONVECTION'],
      type: 'fill'
    },
    {
      layout: {
        'icon-image': 'CONVECTION',
        'icon-size': 0.26,
        'text-field': [
          'concat',
          [
            'case',
            [
              '==',
              MapBoxStyleSpecService.getAttributeFromCompositeObject(
                'convection_type'
              ),
              'ISOL/EMBED'
            ],
            'ISOL\nEMBD',
            [
              '==',
              MapBoxStyleSpecService.getAttributeFromCompositeObject(
                'convection_type'
              ),
              'OCNL/EMBED'
            ],
            'OCNL\nEMBD',
            [
              '==',
              MapBoxStyleSpecService.getAttributeFromCompositeObject(
                'convection_type'
              ),
              'FREQUENT'
            ],
            'FRQ',
            MapBoxStyleSpecService.getAttributeFromCompositeObject(
              'convection_type'
            )
          ],
          '\n',
          'CB',
          '\n',
          MapBoxStyleSpecService.getAttributeFromCompositeObject(
            'conv_upper_level'
          ),
          '\n',
          MapBoxStyleSpecService.getAttributeFromCompositeObject(
            'conv_base_level'
          )
        ],
        'text-size': 7,
        'text-offset': [0, 0.3]
      },
      paint: {
        'text-color': '#C90015'
      },
      source: 'twc',
      minzoom: 0,
      maxzoom: 28,
      'source-layer': 'source-layer',
      id: 'convection-2',
      filter: ['==', 'layer_name', 'CONVECTION'],
      type: 'symbol'
    }
  ];
